import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpService} from "../http/http.service";
import {Newsletter} from "./newsletter";


@Injectable()
export class NewsletterService {
  private url = '/api/newsletter';

  constructor(private httpService: HttpService) {
  }

  create(newsletter: Newsletter): Observable<Newsletter> {
    return this.httpService.post(this.url, newsletter)
      .map(res => res.json() as Newsletter);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/newsletter/newsletter.service.ts